import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Adv2bPage } from './pages/Adv2bPage';
import { WebinarMCPage } from './pages/WebinarMCPage';
import { WebinarMCV2Page } from './pages/WebinarMCV2Page';
import { WebinarMCThankYouPage } from './pages/WebinarMCThankYouPage';
import { MCBedanktPage } from './pages/MCBedanktPage';
import { LiefdevolCommunicerenACPage } from './pages/LiefdevolCommunicerenACPage';
import { BlogStraffenAgressiePage } from './pages/BlogStraffenAgressiePage';
import { BedanktAankoopPage } from './pages/BedanktAankoopPage';
import { MetaPixel } from './components/MetaPixel';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <MetaPixel data-id="element-3" />
      <Routes data-id="element-4">
        <Route path="/" element={<Adv2bPage data-id="element-6" />} data-id="element-5" />
        <Route path="/webinar-mc" element={<WebinarMCPage data-id="element-8" />} data-id="element-7" />
        <Route path="/webinar-mc-v2" element={<WebinarMCV2Page data-id="element-10" />} data-id="element-9" />
        <Route path="/webinar-mc-thank-you" element={<WebinarMCThankYouPage data-id="element-12" />} data-id="element-11" />
        <Route path="/mc-bedankt" element={<MCBedanktPage data-id="element-14" />} data-id="element-13" />
        <Route path="/liefdevol-communiceren-ac" element={<LiefdevolCommunicerenACPage data-id="element-16" />} data-id="element-15" />
        <Route path="/blog-straffen-agressie" element={<BlogStraffenAgressiePage data-id="element-18" />} data-id="element-17" />
        <Route path="/bedankt-aankoop" element={<BedanktAankoopPage data-id="element-20" />} data-id="element-19" />
      </Routes>
    </BrowserRouter>;
}